import { AxiosRequestConfig } from 'axios';
import { ProductL } from '../../type';
import { ResponseT } from '@utils/api/base';
import { Products, Orders } from '@utils/api';
import { handleError } from '@utils/misc';
import useCognito from '@as_core/account/useCognito';

const useProducts = () => {
  const { getToken } = useCognito();

  const getProducts = async (token, params): Promise<ResponseT<ProductL>> => {
    const config: AxiosRequestConfig = { params };
    let resp;

    try {
      resp = await Products.all(token, config);
    } catch (err) {
      handleError(err);
      return null;
    }

    return resp.data;
  };

  const checkCredits = async () => {
    const token = getToken();
    let resp;
    console.log('test 2');

    try {
      resp = await Orders.credits(token);
    } catch (err) {
      handleError(err);
      return null;
    }

    return resp.data;
  };

  return {
    getProducts,
    checkCredits,
  };
};

export default useProducts;
